module.exports = __webpack_public_path__ + "img/06-min.2a9957d4.jpg";